export default __webpack_public_path__ + "media/images/halloween/twinkle-5b7fd7f068e8020138fb5cf71ca17d4b.svg";